import fetch from 'isomorphic-fetch';
import { call } from 'redux-saga/effects'
import localforage from 'localforage';
import { includes } from 'ramda';
import { hasValue } from "@amsanalytics/react-shared-library";

export function* httpPost(
  url: string,
  body: any,
  token: string
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield (call(getClientId));
    const config = yield call(fetchConfig);
    // 
    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'POST', body: JSON.stringify(body) };
    const response: {} = yield call(fetch, url, addHeader(options, token));
    return response;
  } catch (e) {
    // const errorEffect = getErrorEffect(e); // replaces handleError
    // if (errorEffect) {
    //   yield errorEffect;
    // }
  }
}


export function* httpPostFile(
  url: string,
  body: any,
  contentType: string,
  token: string
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield (call(getClientId));
    const config = yield call(fetchConfig);

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'POST', mode: 'cors', body };
    const response: {} = yield call(fetch, url, addFileHeader(options, contentType, token));
    return response;
  } catch (e) {
    // const errorEffect = getErrorEffect(e); // replaces handleError
    // if (errorEffect) {
    //   yield errorEffect;
    // }
  }
}

export function* httpPut(
  url: string,
  body: any,
  token: string
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield (call(getClientId));
    const config = yield call(fetchConfig);

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'PUT', body: JSON.stringify(body) };
    const response: {} = yield call(fetch, url, addHeader(options, token));
    return response;
  } catch (e) {
    // const errorEffect = getErrorEffect(e); // replaces handleError
    // if (errorEffect) {
    //   yield errorEffect;
    // }
  }
}

export const httpPutAsync = async (
  url: string,
  body: any,
  token: string
) => {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = await getClientId() as (string | undefined);
    const config: any = await fetchConfig();

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'PUT', body: JSON.stringify(body) };
    const response = await fetch(url, addHeader(options, token));
    return response;
  } catch (e) {
    // const errorEffect = getErrorEffect(e); // replaces handleError
    // if (errorEffect) {
    //   // yield errorEffect;
    //   alert('error occurred');
    // }
  }
}

export function* httpGet(
  url: string,
  token: string
) {
  try {
    // url = `${url}?clientId=CRM`
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield (call(getClientId));
    const config = yield call(fetchConfig);

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const response: {} = yield call(fetch, url, addHeader({ method: 'GET' }, token));
    return response;
  } catch (e) {
    // const errorEffect = getErrorEffect(e); // replaces handleError
    // if (errorEffect) {
    //   yield errorEffect;
    // }
  }
}

export const httpGetAsync = async (
  url: string,
  token: string
) => {
  try {
    // url = `${url}?clientId=CRM`
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = await getClientId() as (string | undefined);
    const config: any = await fetchConfig();

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }

    const response = await fetch(url, addHeader({ method: 'GET' }, token));
    return response;
  } catch (e) {
    // const errorEffect = getErrorEffect(e); // replaces handleError
    // if (errorEffect) {
    //   // yield errorEffect;
    //   alert('error occurred');
    // }
  }
}
export const httpPostAsync = async (
  url: string,
  body: any,
  token: string
) => {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = await getClientId() as (string | undefined);
    const config: any = await fetchConfig();

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'POST', body: JSON.stringify(body) };
    const response = await fetch(url, addHeader(options, token));
    return response;
  } catch (e) {
    console.error('Error occurred during HTTP POST:', e);
  }
}
export function* httpDelete(
  url: string,
  token: string
) {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string = yield (call(getClientId));
    const config = yield call(fetchConfig);

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const response: {} = yield call(fetch, url, addHeader({ method: 'DELETE' }, token));
    return response;
  } catch (e) {
    // const errorEffect = getErrorEffect(e); // replaces handleError
    // if (errorEffect) {
    //   yield errorEffect;
    // }
  }
}

export const httpDeleteAsync = async (
  url: string,
  token: string
) => {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = await getClientId() as (string | undefined);
    const config: any = await fetchConfig();

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const response = await fetch(url, addHeader({ method: 'DELETE' }, token));
    return response;
  } catch (e) {
    // const errorEffect = getErrorEffect(e); // replaces handleError
    // if (errorEffect) {
    //   // yield errorEffect;
    //   alert('error occurred');
    // }
  }
}

export const httpPatchAsync = async (
  url: string,
  body: any,
  token: string
) => {
  try {
    const getClientId = async () => localforage.getItem('clientId');
    const clientId: string | undefined = await getClientId() as (string | undefined);
    const config: any = await fetchConfig();

    url = `${config.api_endpoint}/${url}`;
    if (hasValue(clientId)) {
      if (includes("?", url)) {
        url = `${url}&clientId=${clientId}`;
      } else {
        url = `${url}?clientId=${clientId}`;
      }
    }
    const options = { method: 'PATCH', body: JSON.stringify(body) };
    const response = await fetch(url, addHeader(options, token));
    return response;
  } catch (e) {
  }
}

/**
 * Add headers to api
 * @param options
 * @param token
 */
function addHeader(options: any = {}, token?: string) {
  const newOptions = { ...options };
  if (!options.headers) {
    newOptions.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...options.headers,
    };
  }
  // Add bearer token if it exists
  if (token) {
    newOptions.headers.Authorization = `Bearer ${token}`;
  }

  return newOptions;
}


/**
 * Add headers to api
 * @param options
 * @param token
 */
function addFileHeader(options: any = {}, contentType: string, token?: string) {
  const newOptions = { ...options };
  if (!options.headers) {
    newOptions.headers = {
      'Content-Type': contentType,
      ...options.headers,
    };
  }
  // Add bearer token if it exists
  if (token) {
    newOptions.headers.Authorization = `Bearer ${token}`;
  }

  return newOptions;
}

export const fetchConfig = async () => {
  try {
    const cacheBuster = new Date().getTime(); // Generate a unique timestamp
    const response = await fetch(`/api-info.apisettings?cacheBuster=${cacheBuster}`);
    if (!response.ok) {
      throw new Error(`Network response was not ok (${response.status} ${response.statusText})`);
    }
    return response.json();
  } catch (error) {
    console.error('Error fetching configuration:', error);
    return null;
  }
};

export function* handleResponse<T>(response: any): Generator<T> {
  const errorStatuses = [400, 401, 403, 404, 409, 500, 502, 503, 504];
  if (!response) {
    throw new Error('No response was received from the server. You can try refreshing the browser. If the problem persists, please contact support.');
  }
  let deserializedResponse: any = null;
  if (response.json) {
    try {
      deserializedResponse = yield call([response, response.json]) as T;
    } catch (e) {
      // Intentionally eat exception. Some responses are not JSON and no error is needed.
    }
  }
  if (response.ok) {
    if (deserializedResponse) {
      return deserializedResponse as T;
    }
    return;
  } else if (includes(response.status, errorStatuses)) {
    if (deserializedResponse && deserializedResponse.errors) {
      const errors: string[] = [];
      Object.keys(deserializedResponse.errors).forEach((key) => {
        errors.push(deserializedResponse.errors[key]);
      });
      throw new Error(errors.join('\n'));
    } else if (deserializedResponse && deserializedResponse.message) {
      throw new Error(deserializedResponse.message);
    } else if (deserializedResponse && deserializedResponse.error) {
      throw new Error(deserializedResponse.error);
    } else if (!deserializedResponse && response.statusText && response.message) {
      throw new Error(response.statusText);
    }
  } else if (response.statusText && response.message) {
    throw new Error(`Network response was not ok (${response.status} ${response.message})`);
  }

  throw new Error(`An error occurred. The server returned a ${response.status} status code.`);
}